import React, { useState, useEffect } from 'react'
import SearchUserModal from './SearchUserModal'
import UserDetailsModal from './UserDetailsModal'
import { useParams } from 'react-router'
import { useErrorService } from '@abroad/components'
import API from '../../utils/API'

const AddUserModal = ({
  showModal,
  handleClose,
  updateParticipants,
  questParticipants,
}) => {
  const [showSearchModal, setShowSearchModal] = useState(false)
  const [showDetailsModal, setShowDetailsModal] = useState(false)
  const [userData, setUserData] = useState(null)
  const [search, setSearch] = useState('')
  const [questDetails, setQuestDetails] = useState()
  const { questId } = useParams()
  const Error = useErrorService()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await API.AdminAPI.quests.getQuestDetail(questId)
        setQuestDetails(data)
      } catch (err) {
        Error.showError(err)
      }
    }

    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questId])

  useEffect(() => {
    if (showModal) {
      setShowSearchModal(true)
      setShowDetailsModal(false)
      setUserData(null)
      setSearch('')
    } else {
      setShowSearchModal(false)
      setShowDetailsModal(false)
      setUserData(null)
      setSearch('')
    }
  }, [showModal])

  const handleUserFound = (user) => {
    setUserData({
      _id: user._id,
      email: user.email,
      firstName: user.fname || '',
      lastName: user.lname || '',
    })
    setShowSearchModal(false)
    setShowDetailsModal(true)
  }

  const handleUserNotFound = (email) => {
    setUserData({
      email,
      firstName: '',
      lastName: '',
    })
    setShowSearchModal(false)
    setShowDetailsModal(true)
  }

  const handleBackToSearch = () => {
    setShowDetailsModal(false)
    setUserData(null)
    setShowSearchModal(true)
  }

  const handleCloseModals = () => {
    setShowSearchModal(false)
    setShowDetailsModal(false)
    setUserData(null)
    setSearch('')
    handleClose()
  }

  return (
    <>
      <SearchUserModal
        showModal={showSearchModal}
        handleClose={handleCloseModals}
        onUserFound={handleUserFound}
        onUserNotFound={handleUserNotFound}
        search={search}
        setSearch={setSearch}
        questParticipants={questParticipants}
      />
      {userData && (
        <UserDetailsModal
          showModal={showDetailsModal}
          handleClose={handleCloseModals}
          onBack={handleBackToSearch}
          userData={userData}
          updateParticipants={updateParticipants}
          questDetails={questDetails}
          investments={questDetails?.investments}
        />
      )}
    </>
  )
}

export default AddUserModal
